import { SiteFailedState } from "./SiteFailed-State";

export default function organizationFailedReducer(
  state = SiteFailedState,
  action
) {
  let { data } = JSON.parse(JSON.stringify(state));
  let { name, value, id } = action;

  switch (action.type) {
    case "TOGGLE-SITE-FAILED-FILTER":
      if (name === `sort_by`) {
        if (data.params.sort_by === value) {
          data.params.sort_order =
            data.params.sort_order === `desc` ? `asc` : `desc`;
        }
      }
      if (name === "limit") {
        data.params.page = 1;
      }
      data.params[name] = value;

      return { ...state, data };

    case "SET-ORGANIZATION-FAILED-ID":
      return { ...state, data: { ...state.data, organization_id: id } };

    case "TOGGLE-SITE-FAILED-MODAL":
      if (data.modal.mode === true) {
        // if open, close
        data.modal = { mode: `` };
      } else {
        // if close, open
        data.modal.mode = true;
      }
      return { ...state, data };

    case "TOGGLE-SITE-FAILED-STATUS-MODAL":
      if (data.status_modal.mode === true) {
        // if open, close
        data.status_modal = { mode: `` };
      } else {
        // if close, open
        data.status_modal.mode = true;
      }
      return { ...state, data };

    default:
      return state;
  }
}
